import React from "react";
import { Container, Row, Col, Card, Badge } from "react-bootstrap";
import "../css/Section3.css";

const Section3 = () => {
  return (
    <section className="wow-section">
      <Container>

        {/* TOP TEXT */}
        <Row className="justify-content-center text-center mb-4">
          <Col lg={10}>
            <p className="intro-text">
              In today's competitive business landscape, a satisfactory
              customer experience can make all the difference between success
              and failure. And…
            </p>

            <h2 className="main-heading">
              Creating WOW moments for customers is a tedious job.
            </h2>

            <div className="highlight-text">
              We make it seamless for you
            </div>
          </Col>
        </Row>

        {/* CARDS */}
        <Row className="g-4 mt-4">
          <Col md={6}>
            <Card className="info-card">
              <Card.Body>
                Founded in 2018 as a subsidiary of{" "}
                <strong>Nimbus Group</strong>, we aim to offer{" "}
                <strong>Contact Center & BPM</strong> services to companies
                looking to enhance their Customer Journey.
              </Card.Body>
            </Card>
          </Col>

          <Col md={6}>
            <Card className="info-card">
              <Card.Body>
                We have worked with various corporations including{" "}
                <strong>Fortune 500 & Unicorns</strong> in last 5 years 🏢
              </Card.Body>
            </Card>
          </Col>

          <Col md={6}>
            <Card className="info-card">
              <Card.Body>
                We envisioned to provide employment in{" "}
                <strong>Metro & Tier 1/Tier 2</strong> cities 🏙️
              </Card.Body>
            </Card>
          </Col>

          <Col md={6}>
            <Card className="info-card">
              <Card.Body>
                Our presence has expanded to{" "}
                <strong>
                  Noida, Ranchi, Bangalore, Kolkata and Ahmedabad
                </strong>{" "}
                🗺️
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* BOTTOM TEXT */}
        <Row className="mt-5">
          <Col className="text-center">
            <p className="bottom-text">
              <strong>
                Nimbus BPO saves you CAPEX, hiring challenges, and liabilities.
              </strong>
            </p>
          </Col>
        </Row>

      </Container>
    </section>
  );
};

export default Section3;
